import React from "react";

import { Link as LinkR } from 'react-router-dom';
// import laptopimage from "../assets/Images/laptop.png";
import './Portfolio.css';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Portfolionext = () => {

  const cardData = [
    {
      id: 1,
      img: "images/portfolionext-cardData/ijarah.png",
      name: "Got Ijarah",
      property: "Mobile App"
    },
    {
      id: 2,
      img: "images/portfolionext-cardData/scouts.jpg",
      name: "Scout Capital",
      property: "Web App"
    },
    {
      id: 3,
      img: "images/portfolionext-cardData/foodninja.png",
      name: "Food Ninja",
      property: "Mobile App"
    },
    {
      id: 4,
      img: "images/portfolionext-cardData/meehelp.png",
      name: "MeeHelp",
      property: "Mobile App"
    },
    {
      id: 5,
      img: "images/portfolionext-cardData/chadster.png",
      name: "Chadster",
      property: "Web App"
    }
  ];

  let settings = {
    dots: true,
    autoplaySpeed: 2000,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ],
    customPaging: index => {
      return (
        <button style={{ backgroundColor: "gainsboro" }}>{index + 1}</button>
      )
    }
  };

  return (
    <div className="portfolio-next-main">
      <header className="portfolio-btn">
        <LinkR to='/' >
          <button style={{ background: 'transparent', color: '#1E978C', border: 'none', outline: 'none' }}>Home</button>
        </LinkR>
        <button>My Portfolio</button>
      </header>
      <section className="main">
        <div style={{ fontWeight: 500, fontSize: 20, textAlign: "center", color: "#1E978C", marginTop: "20px" }}>
          {" "}
          Our Portfolio
        </div>
        <h1>Portfolio Showcase</h1>

        <p className="portfolio-next-p">
          Aizonix Solutions delivers secure, scalable, and AI-driven Web and Mobile applications that boost performance and satisfaction across diverse industries.
Every project is unique—and so is our approach.


        </p>
        {/* <div className="portfolio-next">
        <img className="portfolioimg" src={laptopimage} alt="portfolio" />
        <ul className="portfolio-class">
          <li>Healthcare</li>
          <li>Textile</li>
          <li>E-Commerce</li>
          <li>Logistics</li>
          <li>Financial Services</li>
          <li>Telecommunications</li>
          <li>Real Estate</li>
          <li>Retail & Distribution</li>
          <li>Automobile</li>
        </ul>
      </div> */}
        <div className="cards-container">
          <Slider {...settings} className="cards">
            {cardData.map((item) => (
              <div className="card-div" key={item.id}>
                <div className="img-div">
                  <img src={item.img} alt="avatar" className="img" height="280px" width="300px" />
                </div>
                <div className="card-text">
                  <div className="card-name">{item.name}</div>
                  <div className="card-property">{item.property}</div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="portfolio-2">
          <p>Insightful thinking, data-driven research, and verified metrics—helping you make smarter decisions.</p>
        </div>
      </section>
    </div>
  );
};

export default Portfolionext;